import { useState } from "react";
import { Controller } from "react-hook-form";
import {
  BORDER,
  FOCUS_RING,
  INK,
  OVERDUE_BG,
  OVERDUE_FG,
} from "../../Utils/designTokens";

/**
 * CRL-3241: plain text field in the login form's `.phone-input` look — no
 * floating label (the label is the placeholder), 56px tall, 14px radius,
 * focus ring, reserved error line below.
 */
export default function RHFInput({
  name,
  label,
  type = "text",
  error,
  control,
  inputRef,
  maxLength,
  placeholder,
  onFocus,
  onBlur,
  onChange,
}: any) {
  const [isFocused, setIsFocused] = useState(false);
  const showError = !isFocused && !!error;

  const borderColor = showError ? OVERDUE_FG : isFocused ? INK : BORDER;
  const ring = showError
    ? `0 0 0 4px ${OVERDUE_BG}`
    : isFocused
      ? `0 0 0 4px ${FOCUS_RING}`
      : "none";

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const { onBlur: fieldOnBlur, onChange: fieldOnChange, ref, value, ...fieldProps } = field;

        return (
          <div className="w-full">
            <div
              className="flex items-center h-14 px-4 rounded-[14px] bg-white"
              style={{
                border: `1.5px solid ${borderColor}`,
                boxShadow: ring,
                transition: "border-color .15s, box-shadow .15s",
              }}
            >
              <input
                {...fieldProps}
                ref={(el) => {
                  ref(el);
                  if (inputRef) inputRef.current = el;
                }}
                value={value ?? ""}
                type={type}
                maxLength={maxLength}
                placeholder={placeholder ?? label}
                aria-label={label}
                className="w-full min-w-0 h-full bg-transparent border-0 outline-none text-[16px] font-medium placeholder:font-normal placeholder:text-[#94A3B8]"
                style={{ color: INK }}
                onFocus={() => {
                  setIsFocused(true);
                  if (onFocus) onFocus();
                }}
                onBlur={() => {
                  setIsFocused(false);
                  fieldOnBlur();
                  if (onBlur) onBlur();
                }}
                onChange={(e) => {
                  fieldOnChange(e);
                  if (onChange) onChange(e.target.value);
                }}
              />
            </div>
            <div
              className="mt-[7px] min-h-[16px] text-[12.5px]"
              style={{ color: OVERDUE_FG }}
              aria-live="polite"
            >
              {showError ? error?.message : ""}
            </div>
          </div>
        );
      }}
    />
  );
}
